import { cva } from 'class-variance-authority';

export const tableWrapperClasses = cva('relative w-full overflow-auto');

export const tableClasses = cva('w-full table-auto');

export const tableHeaderClasses = cva('bg-cloud-200');

export const tableHeadClasses = cva('px-2 py-4 text-left first:pl-4 last:pr-4');

export const tableRowClasses = cva('border-cloud-400 border-b', {
  variants: {
    onClick: {
      true: 'hover:bg-cloud-200 cursor-pointer',
      false: 'cursor-default'
    }
  },
  defaultVariants: {
    onClick: false
  }
});

export const tableCellClasses = cva('px-2 py-4 first:pl-4 last:pr-4');
